export default "/images/vendor/flag-icons/flags/4x3/tc.svg?ffdbcf45e2e3c21bf57111f233581891";